import instance from "../Config/Config";

export const gioo_pay_url = "gioo_pay"
export const doc_pay_url = "market_document_pay"
export const market_pay_url = "market_pay"
// 22/1/26
export const rental_document_pay_url = "rental_document_pay"
export const residential_transaction_url = "my-residential-transactions"
export const market_transaction_url = "my-market-transactions"
export const syndicate_transaction_url = "my-syndicate-transactions"
export const gioo_transaction_url = "my-gioo-transactions"
export const rental_transaction_url = "my-rental-transactions"
export const syndicate_plot_pay_url = "syndicate_pay"
export const syndicate_doc_pay_url = "syndicate_pay"
export const residential_verify_pay_url = "residential_pay"

export const pay_gioo_plot = async(value)=>{
    const response = await instance.post(`${gioo_pay_url}`, value)
    return response.data
}

export const doc_pay = async(value)=>{
    const response = await instance.post(`${doc_pay_url}`, value)
    return response.data
}

export const market_pay = async(value)=>{
    const response = await instance.post(`${market_pay_url}`, value)
    return response.data
}

//syndicate
export const syndicate_plot_pay = async (value) =>{
     const response = await instance.post(`${syndicate_plot_pay_url}`, value)
    return response.data
}

export const syndicate_doc_pay = async(value)=>{
    const response = await instance.post(`${syndicate_doc_pay_url}`, value)
    return response.data
}

// rental

export const rental_document_pay = async(value)=>{
    const response = await instance.post(`${rental_document_pay_url}`, value)
    return response.data
}

export const residential_transaction_list = async (page) => {
    const response = await instance.get(`${residential_transaction_url}?page=${page}`)
    return response.data
}
export const syndicate_transaction_list = async (page) => {
    const response = await instance.get(`${syndicate_transaction_url}?page=${page}`)
    return response.data
}
export const gioo_transaction_list = async (page) => {
    const response = await instance.get(`${gioo_transaction_url}?page=${page}`)
    return response.data
}
export const marketplace_transaction_list = async (page) => {
    const response = await instance.get(`${market_transaction_url}?page=${page}`)
    return response.data
}

export const rental_transaction_list = async (page) => {
    const response = await instance.get(`${rental_transaction_url}?page=${page}`)
    return response.data
}

export const residential_verify_pay = async(value)=>{
    const response = await instance.post(`${residential_verify_pay_url}`, value)
    return response.data
}